import api from './api';
import ProductType from './product-type';
import { CardMedia, BackgroundMedia, Availabilities } from '@/utils/types';
import Product from './product';

export interface ProductPageInterface {
    id: number;
    name: string;
    description: string;
    slug: string;
    shown_on_homepage: boolean;
    schedule: Availabilities;
    product_types: ProductType[];
    products: Product[];
    image: CardMedia;
    background: BackgroundMedia | null;
    parent: ProductPageInterface | null;
    children: ProductPageInterface[];
}

export default class ProductPage implements ProductPageInterface {
    id: number;
    name: string;
    description: string;
    slug: string;
    shown_on_homepage: boolean;
    schedule: Availabilities;
    product_types: ProductType[];
    products: Product[];
    image: CardMedia;
    background: BackgroundMedia | null;
    parent: ProductPage | null;
    children: ProductPage[];

    constructor(productPage: ProductPageInterface) {
        this.id = productPage.id;
        this.name = productPage.name;
        this.description = productPage.description || '';
        this.slug = productPage.slug;
        this.shown_on_homepage = (productPage.shown_on_homepage) ? true : false;
        this.schedule = productPage.schedule;
        this.product_types = productPage.product_types;
        this.products = productPage.products;
        this.image = productPage.image;
        this.background = productPage.background;
        this.parent = (productPage.parent) ? new ProductPage(productPage.parent) : null;
        this.children = [];
        if (productPage.children) {
            this.children = ProductPage.createBatch(productPage.children);
        }
    }

    static async all(): Promise<ProductPage[]> {
        const response = await api.get<ProductPageInterface[]>({name: 'product_page.index'});
        if (response.success) {
            return ProductPage.createBatch(<ProductPageInterface[]>response.content);
        }
        return [];
    }

    static createBatch(productPages: ProductPageInterface[]): ProductPage[] {
        let productPagesInstances = [];
        for (let index = 0; index < productPages.length; index++) {
            productPagesInstances.push(new ProductPage(productPages[index]));
        }
        return productPagesInstances as ProductPage[];
    }
}
